"use client";

import { useState } from "react";
import { ListingsCarousel } from "@/components/listings-carousel";
import type { ListingItem } from "@/components/Landing/components/simple-listing-card";

export function LoginCarousel({ initialItems }: { initialItems: ListingItem[] }) {
  const [items] = useState(initialItems);
  return <ListingsCarousel items={items} />;
}
